<template>
  <v-dialog v-model="isOpen" max-width="500px" persistent>
    <v-card>
      <div class="d-flex pa-3 gap-3">
        <img src="@/assets/img/edgefirst_hexagon.svg" alt="EdgeFirst Studio" width="100" height="100">
        <div class="d-flex flex-column gap-3 flex-grow-1">
          <div class="d-flex justify-end">
            <v-btn icon size="small" @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <p class="text-body1 mb-0 px-3 py-2">
            Sign in to access profiling results, datasets and models for free.
          </p>
        </div>
      </div>

      <v-card-text class="text-center pt-0 pb-6">

        <div class="space-y-3">
          <v-btn
            block
            color="primary"
            size="large"
            class="mb-3"
            @click="navigateToLogin"
          >
            Sign In
          </v-btn>

          <v-btn
            block
            variant="outlined"
            color="primary"
            size="large"
            @click="navigateToSignup"
          >
            Create Account
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center pb-4">
        <span class="text-caption text-disabled">
          You can explore public content or sign in to continue.
        </span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { safeSessionStorage } from '@/utils/safeStorage';

const router = useRouter();
const route = useRoute();
const store = useStore();

const isOpen = ref(false);
const returnPath = ref(null);
let reopenTimeout = null;

const hasToken = computed(() => !!store.state.user.token);

onMounted(() => {
  // Store the current path to redirect back after login
  returnPath.value = route.path;
  checkAndShow();
});

onUnmounted(() => {
  if (reopenTimeout) {
    clearTimeout(reopenTimeout);
  }
});

function checkAndShow() {
  if (!hasToken.value) {
    isOpen.value = true;
  }
}

function handleClose() {
  isOpen.value = false;
  // Re-show after 2 seconds
  if (reopenTimeout) {
    clearTimeout(reopenTimeout);
  }
  reopenTimeout = setTimeout(() => {
    checkAndShow();
  }, 2000);
}

function navigateToLogin() {
  // Store the return path in session storage so it survives OAuth redirects
  if (returnPath.value && returnPath.value !== '/login' && returnPath.value !== '/signup') {
    safeSessionStorage.setItem('login_return_path', returnPath.value);
  }
  router.push({
    path: '/login',
    query: { redirectPath: returnPath.value }
  });
}

function navigateToSignup() {
  // Store the return path in session storage so it survives OAuth redirects
  if (returnPath.value && returnPath.value !== '/login' && returnPath.value !== '/signup') {
    safeSessionStorage.setItem('login_return_path', returnPath.value);
  }
  router.push({
    path: '/signup',
    query: { redirectPath: returnPath.value }
  });
}
</script>

<style lang="scss" scoped>
.space-y-3 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
